import { doPost } from '../services/http';
import {
  releaseVersion,
} from './urls';

export const updateReleaseVersion = (url, data) => doPost(`${url}${releaseVersion}`.replace('{version}', data.version), data);
